import Badge from '../badge';
import './styles.scss';
import { ReactComponent as ArrowLeftIcon } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as TicketIcon } from '../../assets/icons/ticket.svg';
import Button from '../button';



export default function Pricing({ displayCTA = true }) {
    return (
        <div className="pricing mt-3 mb-3">
            <div className="container">
                <Badge
                    text="Transparência e confiança, sem taxas escondidas"
                    variant="secondary"
                    leftIcon={<TicketIcon />}
                />
                <h1>Lucre com a sua plataforma e só pague quando vender</h1>
                <h4 style={{ width: '80%' }}>No Ginastee você não paga nenhuma mensalidade, apenas
                    uma taxa justa quando vender um produto.</h4>

                <h1 className="mt-2 mb-2 price-percentile" >9,49% <h5 className='price-fixed'>+ R$1,99</h5></h1>
                <span className='pb-3' style={{ fontSize: '20px !important', fontWeight: '600 !important' }}>por cobrança recebida</span>
                {displayCTA && (
                    <Button.Large
                        text="Criar minha comunidade agora"
                        rightIcon={<ArrowLeftIcon />}
                        onClick={window.config.redirects.openApp}
                    />
                )}
            </div>
        </div>
    )
}